


























import FlexiColourStrip from './scripts';
export default FlexiColourStrip;
